import { useMutation } from '@tanstack/react-query'

import { integrationAPI } from '@/api/new-api'
import { resetQueries } from '@/utils'

import { getIglooWorksStatusQueryKey } from './get-igloo-works-status'

type UpdateIglooWorksConnectionRequest = {
  buildingId: number
  clientId: string
  clientSecret: string
  config: {
    shouldAutoAssignApartmentDoor: boolean
    shouldAutoAssignApartmentDoorVisitor: boolean
    permissionDoors: Record<string, string>
    visitorPermissionDoors: Record<string, string>
  }
}

const updateIglooWorksConnection = async (data: UpdateIglooWorksConnectionRequest) => {
  const { buildingId, ...body } = data
  const response = await integrationAPI.post(`/igloowork/building/${buildingId}/connect`, body)
  return response.data
}

export const useUpdateIglooWorksConnection = () =>
  useMutation({
    mutationFn: updateIglooWorksConnection,
    onSuccess: async (_data, variables) => {
      await resetQueries([getIglooWorksStatusQueryKey({ buildingId: variables.buildingId })])
    },
  })
